import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { resourcesCreateView } from './create/create';
import { ResourcesDetailView } from './detail/detail';
import { ResourcesEditView } from './edit/edit';
import { ResourcesInstancesView } from './instances/instances';

export const ResourcesView = angular
  .module('acme.view.application.resources', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.resources.controllers',
    resourcesCreateView,
    ResourcesEditView,
    ResourcesDetailView,
    'acme.view.application.resources.requests',
    'acme.view.application.resources.personnel',
    'acme.view.application.resources.facilities',
    'acme.view.application.resources.equipment',
    ResourcesInstancesView,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.resources',
      url: '/resources',
      abstract: true,
      views: {
        'subview-main': {
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/resources/resources.tpl.html',
        },
      },
      data: {
        pageTitle: 'Resources',
        roles: ['admin'],
      },
    });

    $stateProvider.state({
      name: 'application.resources.list',
      url: '',
      views: {
        'subview-main': {
          controller: 'ResourcesController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/resources/resourcesList.tpl.html',
        },
      },
      data: {
        pageTitle: 'Resources Templates',
        rule: function (permits) {
          // Allow if state is not in exclusions array
          return permits.indexOf('application.resources.list') !== -1;
        },
      },
    });
  }).name;
